import {
  useDeleteCardBenefitMutation,
  FeePeriodsByAccountDocument,
} from '@transactions/graphql';
import * as React from 'react';
import {Button} from 'src/Button';
import {Modal} from 'src/Modal';
import type {FullCardBenefitFragment} from '@transactions/graphql';
import type {SystemProps} from 'src/Modals';

export type DeleteCardBenefitModalUserProps = {
  benefit: FullCardBenefitFragment;
  onDeleted: () => void;
};

export const DeleteCardBenefitModal = (
  props: DeleteCardBenefitModalUserProps & SystemProps,
) => {
  const {benefit, onRequestClose, onDeleted} = props;
  const [deleteBenefit, {loading}] = useDeleteCardBenefitMutation();
  const [error, setError] = React.useState<string | null>(null);

  const handleDelete = async () => {
    setError(null);
    try {
      await deleteBenefit({
        variables: {id: benefit._id},
        refetchQueries: [
          {
            query: FeePeriodsByAccountDocument,
            variables: {accountId: benefit.accountId},
          },
        ],
      });
      onDeleted();
      onRequestClose();
    } catch (e: unknown) {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
      const err = e as Error;
      setError(err.message);
    }
  };

  const footer = (
    <>
      <Button variant="outline" onClick={onRequestClose} disabled={loading}>
        Cancel
      </Button>
      <Button
        variant="destructive"
        // eslint-disable-next-line @typescript-eslint/no-misused-promises
        onClick={handleDelete}
        disabled={loading}
      >
        {loading ? 'Deleting...' : 'Delete'}
      </Button>
    </>
  );

  return (
    <Modal
      onRequestClose={onRequestClose}
      header="Delete benefit"
      footer={footer}
      size="sm"
    >
      {error && (
        <div className="bg-destructive/10 text-destructive mb-3 rounded-md p-3 text-sm">
          {error}
        </div>
      )}
      <p>
        Are you sure you want to delete <strong>{benefit.name}</strong>? This
        action cannot be undone.
      </p>
    </Modal>
  );
};
